import React from 'react'
import styled from 'styled-components'
import { vc_base, vc_color } from '../../assets/js/Brand'
import { media } from '../../assets/js/Helper'

const DetailContents = (props) => (
  <DetailTag dangerouslySetInnerHTML={props.detailContents} />
)

export default DetailContents

// style
const DetailTag = styled.div`
  font-size: 1.6rem;
  line-height: 2;
  ${media.Large`
		font-size: 1.8rem;
	`}
  h2 {
    border-left: ${vc_base.pixel`0.5`} solid ${vc_color.primary};
    font-size: 1.8rem;
    font-weight: bold;
    line-height: 1.25;
    line-height: 1.5;
    margin-top: ${vc_base.pixel`7.5`};
    padding-bottom: ${vc_base.pixel`1.5`};
    padding-left: ${vc_base.pixel`2`};
    padding-right: ${vc_base.pixel`2`};
    padding-top: ${vc_base.pixel`1.5`};
    ${media.Large`
			font-size: 2.0rem;
		`}
  }
  p,
  ul,
  ol {
    padding-bottom: 1em;
    padding-top: 1em;
  }
  p {
    line-height: 2;
    code {
      background-color: ${vc_color.bg_light};
      color: ${vc_color.text};
      padding: 0.25em;
    }
  }
  ul {
    list-style: disc;
  }
  ol {
    list-style: decimal;
  }
  ul,
  ol {
    line-height: 1.75;
    padding-left: 1.5em;
    p {
      display: inline;
      padding: 0;
    }
    ul {
      list-style: circle;
    }
    ul,
    ol {
      padding: 0;
      padding-left: 1.5em;
      ul {
        list-style: square;
      }
    }
  }
  table,
  pre {
    font-size: 1.4rem;
    line-height: 1.5;
    ${media.Large`
			font-size: 1.6rem;
		`}
  }
  table {
    border-bottom: 1px solid ${vc_color.border};
    border-right: 1px solid ${vc_color.border};
    margin-bottom: 1em;
    margin-top: 1em;
    max-width: 100%;
    thead {
      tr {
        th {
          background: ${vc_color.bg_light};
          border-left: 1px solid ${vc_color.border};
          border-top: 1px solid ${vc_color.border};
          padding: 0.75rem 1.25rem;
        }
        td {
          border-left: 1px solid ${vc_color.border};
          border-top: 1px solid ${vc_color.border};
          padding: 0.75rem 1.25rem;
        }
      }
    }
    tbody {
      tr {
        th {
          background: ${vc_color.bg_light};
          border-left: 1px solid ${vc_color.border};
          border-top: 1px solid ${vc_color.border};
          padding: 0.75rem 1.25rem;
        }
        td {
          border-left: 1px solid ${vc_color.border};
          border-top: 1px solid ${vc_color.border};
          padding: 0.75rem 1.25rem;
        }
      }
    }
  }
  pre {
    background-color: ${vc_color.bg_light};
    color: ${vc_color.text};
    padding: 0.75em 1em;
    code {
      white-space: pre-wrap;
      word-break: break-all;
    }
  }
  details {
    margin-top: 1.5em;
    p {
      border: 1px solid ${vc_color.border};
      padding: 0.75rem 1.25rem;
    }
  }
  i {
    margin-right: 0.5em;
    &.fas.fa-exclamation-circle {
      color: ${vc_color.exclamation};
    }
  }
  .list-title {
    font-weight: bold;
    padding-bottom: 0;
    & + ul,
    & + ol {
      padding-top: 0;
    }
  }
  .gatsby-resp-image-wrapper {
    margin-left: 0;
    margin-right: 0;
  }
  .alert {
    font-size: 1.4rem;
    line-height: 1.75;
    margin-bottom: 1.2em;
    margin-top: 1.2em;
    padding: 0.75em 1.5em;
    ${media.Large`
			font-size: 1.5rem;
		`}
    p,
    ul,
    ol {
      padding-bottom: 0.5em;
      padding-top: 0.5em;
    }
    p {
      line-height: 1.75;
    }
    i {
      &.fas.fa-exclamation-circle {
        color: unset;
      }
    }
  }
  .alert-border {
    border: 1px solid ${vc_color.link};
    border-radius: 0.25rem;
    color: ${vc_color.link_hover};
  }
  .tally {
    counter-reset: tally;
    p {
      line-height: 1.5;
      em {
        font-style: normal;
        font-weight: bold;
      }
    }
    span {
      background-color: ${vc_color.tally};
      border-radius: 100%;
      counter-increment: tally;
      display: inline-block;
      font-style: normal;
      font-weight: bold;
      margin-left: -0.4em;
      margin-top: -${vc_base.pixel`0.25`};
      transform: scale(0.5625);
      &::before {
        align-items: center;
        color: ${vc_color.light};
        content: counter(tally);
        display: flex;
        justify-content: center;
        min-height: ${vc_base.pixel`4`};
        min-width: ${vc_base.pixel`4`};
      }
    }
  }
  .note {
    counter-reset: note;
    margin-top: ${vc_base.pixel`5`};
    p {
      display: block;
      font-size: 1.1rem;
      line-height: 1.5;
      padding-bottom: 0.25em;
      padding-left: 1.3em;
      padding-top: 0.25em;
      text-indent: -1.3em;
      ${media.Large`
				font-size: 1.3rem;
			`}
      &::before {
        content: '※ ';
      }
    }
  }
  .scroll-table {
    overflow: auto;
    padding-bottom: ${vc_base.pixel};
    white-space: nowrap;
    &::-webkit-scrollbar {
      height: ${vc_base.pixel`0.5`};
    }
    &::-webkit-scrollbar-track {
      background: ${vc_color.bg_dark};
    }
    &::-webkit-scrollbar-thumb {
      background: ${vc_color.text_gray};
    }
    ${media.Large`
			white-space: normal;
		`}
    table {
      width: auto;
    }
  }
`
